import React, { useContext, useEffect, useRef, useState } from "react";
import { HambergerMenu, Notification } from "iconsax-react";
import { useNavigate } from "react-router-dom";
import { Avatar, LogOut, MyProfile } from "../assets/svg";
import layoutContext from "./layoutContext";
import { useDispatch, useSelector } from "react-redux";
import { adminGetProfileData } from "../redux/auth/slice";
import ConfirmationModel from "../components/common/ConfirmationModel";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { isAsideOpen, setIsAsideOpen } = useContext(layoutContext);

  const { getProfileData } = useSelector((store) => ({
    getProfileData: store?.authData?.adminGetProfileDataStatus?.data,
  }));

  useEffect(() => {
    dispatch(adminGetProfileData({ navigate }));
  }, [dispatch]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const logOutClear = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <header className="sticky top-0 left-0 w-full z-[9]">
        <div className="shadow-md bg-headerDark h-16 w-full flex justify-between items-center px-4">
          <div className="flex gap-2 cursor-pointer">
            <span onClick={() => setIsAsideOpen(!isAsideOpen)}>
              <div className="text-white flex items-center">
                <HambergerMenu size="22" className="mr-3" />
                <p className="text-base font-figtree">Healthy Roots</p>
              </div>
            </span>
          </div>
          <div className="flex items-center space-x-5">
            <div className="cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
              <Avatar />
            </div>
          </div>
        </div>

        {/* Profile Dropdown */}
        {isOpen && (
          <div className="static flex justify-end">
            <div
              ref={profileRef}
              className="bg-primarywhite rounded-2xl shadow-xl absolute pb-2 top-20 right-6 w-[20%]"
            >
              <div className="px-5 pb-4">
                <div className="py-4 flex">
                  <div className="ml-2">
                    <p className="font-poppins font-normal text-base text-black">
                      {getProfileData?.firstName}
                    </p>
                    <p className="font-poppins font-normal text-sm text-textSecondary">
                      {getProfileData?.lastName}
                    </p>
                  </div>
                </div>
              </div>
              <p className="border border-lightgrey" />
              <div className="mt-2">
                <button
                  className="hover:bg-lightgrey text-black p-1 w-full justify-start"
                  onClick={() => {
                    navigate("/profile");
                    setIsOpen(false);
                  }}
                >
                  <div className="px-4 flex items-center">
                    <MyProfile />
                    <p className="ml-4 font-poppins font-normal text-base">
                      My Profile
                    </p>
                  </div>
                </button>
              </div>
              <div className="ml-1">
                <button
                  className="hover:bg-lightgrey text-black p-1 w-full justify-start"
                  onClick={() => setIsModalVisible(true)}
                >
                  <div className="px-4 flex items-center">
                    <LogOut />
                    <p className="ml-4 font-poppins font-normal text-base">
                      Logout
                    </p>
                  </div>
                </button>
              </div>
            </div>
          </div>
        )}
      </header>
      {/* Logout Confirmation Modal */}
      {isModalVisible && (
        <ConfirmationModel
          onConfirm={logOutClear}
          confirmText="Logout"
          onClose={() => setIsModalVisible(false)}
        />
      )}
    </>
  );
};

export default Header;
